/* unplugin-vue-components disabled */import script from "./International_1.vue?vue&type=script&lang=ts&setup=true"
export * from "./International_1.vue?vue&type=script&lang=ts&setup=true"

import "./International_1.vue?vue&type=style&index=0&id=0fe27a5e&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fe27a5e"]])

export default __exports__